
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Tempotravelleronrent() {



  const cardData =
  {
    keyword: 'Tempo Traveller On Rent in Pune for Outstation ',
    heading: 'SHREE Tours & Travels: Tempo Traveller On Rent in Pune for Outstation ',
    headingDescription: 'SHREE Tours & Travels offers Tempo Traveller on rent in Pune for outstation, providing a spacious and comfortable travel experience for family trips, corporate outings, pilgrimages and group tours. Whether you need a vehicle for a one-way journey, round trip, weekend getaway, or long-distance travel, our well-maintained Tempo Traveller ensures a smooth, hassle-free and enjoyable ride. With different seating options (9-seater, 12-seater, 17-seater, etc.), professional drivers, ample luggage space and affordable pricing, we guarantee a convenient and reliable travel experience. Choose SHREE Tours & Travels for the best Tempo Traveller rental service in Pune for outstation trips.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',
"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historic fortification built in 1732 and served as the seat of the Peshwas of the Maratha Empire. This grand palace is known for its majestic entrance, intricate wooden carvings and sprawling gardens. Despite being largely destroyed by a fire in 1828, its ruins still stand as a reminder of Pune’s glorious past. Visitors can explore the remains of the palace, enjoy the light and sound show in the evening and learn about the legends of the fort, including its famous haunted stories."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, Aga Khan Palace is a significant historical landmark. It played a crucial role in India's independence movement, as Mahatma Gandhi, Kasturba Gandhi and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with rare photographs, personal belongings of Gandhi and an eternal flame in honor of freedom fighters. The Italian-style architecture and beautifully maintained gardens make it a peaceful and educational visit."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Situated on a hilltop, Sinhagad Fort is an iconic landmark known for its historical significance and breathtaking views. The fort was the site of the famous Battle of Sinhagad in 1670, where Tanaji Malusare, a brave Maratha warrior, fought for Chhatrapati Shivaji Maharaj. It is a popular trekking destination, offering a rewarding climb with stunning views of the Sahyadri mountains. Visitors can enjoy local Maharashtrian delicacies like pithla-bhakri and kanda bhaji at small eateries near the fort."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. The temple is carved from a single basalt rock and features massive pillars, intricate sculptures and a Nandi (bull) statue. Its unique architecture and serene ambiance make it a fascinating place for history and spirituality enthusiasts. The temple offers a peaceful escape from the bustling city and is an ideal spot for meditation."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum is a treasure trove of India’s cultural heritage, featuring over 20,000 artifacts collected by Dr. Dinkar Kelkar. The museum showcases a diverse collection of ancient musical instruments, traditional weapons, sculptures, paintings and beautifully carved doors. One of its highlights is the ‘Mastani Mahal,’ a reconstructed palace of Bajirao Peshwa’s beloved queen. This museum provides a captivating insight into India’s artistic and historical richness."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is an artificial lake that attracts nature lovers and birdwatchers. It is home to various migratory birds, making it a paradise for photographers and wildlife enthusiasts. The lake has a well-maintained walking track, making it a great spot for morning and evening strolls. The tranquil surroundings and fresh air offer a refreshing break from the city's hustle and bustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is one of the world’s most famous spiritual centers. It offers various meditation programs, yoga sessions and wellness therapies, attracting visitors from across the globe. The ashram promotes a unique blend of Eastern and Western spiritual practices. Visitors can also explore the beautifully landscaped Osho Teerth Park nearby, making it a great place for relaxation and self-discovery."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples, attracting thousands of devotees. The temple is dedicated to Lord Ganesha and features a magnificent idol adorned with gold and jewels. During the Ganesh Chaturthi festival, the temple becomes a major attraction with grand celebrations and processions. The temple’s divine ambiance and spiritual significance make it a must-visit for religious and cultural travelers."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Spread across 130 acres, the Rajiv Gandhi Zoological Park consists of a zoo, a snake park and a wildlife rescue center. It houses a variety of animals, including tigers, leopards, crocodiles and elephants. The snake park is one of its major attractions, featuring different species of snakes and reptiles. The well-maintained environment and educational exhibits make it an excellent place for family outings and nature lovers."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam is a popular weekend getaway located on the Mutha River. It serves as the primary water source for Pune and is surrounded by picturesque hills and lush greenery. Visitors can enjoy breathtaking sunset views, take leisurely walks along the dam, or relish street food like vada pav and roasted corn from local vendors. The nearby Sinhagad Fort and Panshet Dam add to its appeal, making it a perfect one-day picnic spot."
    }
],  
    
            
"services": [
    {
      "name": "Tempo Traveller Rental Pune",
      "description": "Rent a Tempo Traveller in Pune for group travel. With various seating options and ample space for luggage, it's the ideal vehicle for family trips, corporate events and outstation travel."
    },
    {
      "name": "Rent 17 Seater Tempo Traveller Pune",
      "description": "Book a 17-seater Tempo Traveller in Pune for a comfortable group trip. Perfect for family gatherings, group tours, or corporate outings, offering ample space and comfort for everyone."
    },
    {
      "name": "Rent 20 Seater Tempo Traveller Pune",
      "description": "Rent a 20-seater Tempo Traveller in Pune for large group travel. Whether it’s for a family vacation or corporate event, enjoy a spacious and comfortable ride for all passengers."
    },
    {
      "name": "Rent 25 Seater Tempo Traveller Pune",
      "description": "Rent a 25-seater Tempo Traveller in Pune for a larger group. Perfect for group tours, family trips, or corporate events, this vehicle offers comfort and plenty of space for everyone."
    },
    {
      "name": "Rent 32 Seater Tempo Traveller Pune",
      "description": "Book a 32-seater Tempo Traveller in Pune for an even larger group. Ideal for school trips, corporate events, or large family outings, this vehicle ensures comfort and convenience for long journeys."
    },
    {
      "name": "Affordable Tempo Traveller Hire Pune",
      "description": "Looking for a budget-friendly yet comfortable option for group travel? Rent an affordable Tempo Traveller in Pune and enjoy a smooth ride without breaking the bank."
    },
    {
      "name": "Tempo Traveller for Group Travel Pune",
      "description": "Hire a Tempo Traveller in Pune for group travel. With ample seating and luggage space, it’s perfect for family outings, group tours and corporate events, ensuring a comfortable journey for all."
    },
    {
      "name": "Book Tempo Traveller for Outstation Pune",
      "description": "Travel to outstation destinations in comfort with a Tempo Traveller from Pune. Whether it’s a family vacation or a corporate trip, this vehicle provides ample space and convenience for long-distance travel."
    },
    {
      "name": "Tempo Traveller Hire for Family Travel Pune",
      "description": "Rent a Tempo Traveller for family travel in Pune. With spacious seating and comfort for long journeys, it’s the perfect vehicle for family vacations or gatherings."
    },
    {
      "name": "Pune to Outstation in Tempo Traveller",
      "description": "Book a Tempo Traveller for your outstation trips from Pune. With plenty of space and a smooth ride, it's ideal for long-distance travel with a group, family, or colleagues."
    },
    {
      "name": "Tempo Traveller Hire for Corporate Events Pune",
      "description": "Rent a Tempo Traveller for corporate events in Pune. Whether it's for employee transport, client visits, or business meetings, enjoy comfort and professionalism on the road."
    },
    {
      "name": "Rent Tempo Traveller for Large Groups Pune",
      "description": "Rent a Tempo Traveller for large groups in Pune. With various seating options available, it’s perfect for large family gatherings, corporate trips and group travel needs."
    },
    {
      "name": "Tempo Traveller for Weekend Trip Pune",
      "description": "Hire a Tempo Traveller for your weekend getaway from Pune. Enjoy a comfortable and spacious ride for your group as you explore nearby destinations or relax during your weekend trip."
    },
    {
      "name": "Luxury Tempo Traveller Rental Pune",
      "description": "Experience luxury travel with a Tempo Traveller rental in Pune. With plush interiors and plenty of space, it's perfect for those looking for comfort and style during their group travel."
    }
  ],
  "tableData": [
    ["- Tempo Traveller Rental Pune", "- Rent 17 Seater Tempo Traveller Pune"],
    ["- Rent 20 Seater Tempo Traveller Pune", "- Rent 25 Seater Tempo Traveller Pune"],
    ["- Rent 32 Seater Tempo Traveller Pune", "- Affordable Tempo Traveller Hire Pune"],
    ["- Tempo Traveller for Group Travel Pune", "- Book Tempo Traveller for Outstation Pune"],
    ["- Tempo Traveller Hire for Family Travel Pune", "- Pune to Outstation in Tempo Traveller"],
    ["- Tempo Traveller Hire for Corporate Events Pune", "- Rent Tempo Traveller for Large Groups Pune"],
    ["- Tempo Traveller for Weekend Trip Pune", "- Luxury Tempo Traveller Rental Pune"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Spacious and Comfortable for Long Journeys",
      "WhyChoosedescription": "The Tempo Traveller is the perfect vehicle for outstation trips, offering ample space and comfort for group travel. With seating for up to 12-16 passengers, it ensures that your group can travel together comfortably while enjoying spacious interiors, air-conditioning and a smooth ride on long-distance journeys."
    },
    {
      "WhyChooseheading": "Ideal for Group and Family Outings",
      "WhyChoosedescription": "Whether you're planning a family vacation, a group trip, or a corporate outing, the Tempo Traveller provides the ideal space for everyone. Its large seating capacity and generous luggage space make it perfect for long-distance travel, ensuring a relaxing and enjoyable journey for your entire group."
    },
    {
      "WhyChooseheading": "Well-Maintained and Safe Vehicles",
      "WhyChoosedescription": "We ensure that all our Tempo Traveller vehicles are meticulously maintained and regularly serviced to ensure reliability and safety. Our vehicles undergo thorough inspections for cleanliness, mechanical performance and safety features, giving you peace of mind while traveling outstation."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced in long-distance travel, ensuring a smooth, safe and comfortable ride for all passengers. They are familiar with the best routes and take extra care to prioritize safety, comfort and punctuality, making your outstation journey stress-free and enjoyable."
    },
    {
      "WhyChooseheading": "Perfect for Outstation Travel",
      "WhyChoosedescription": "The Tempo Traveller is designed to handle outstation journeys with ease. Its spacious interiors, comfortable seats and reliable performance make it an excellent choice for travel to nearby cities, tourist destinations, or long-distance trips, ensuring a hassle-free travel experience for your group."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking the Tempo Traveller for your outstation trip with SHREE Tours & Travels is quick and easy. You can reserve your vehicle online via our user-friendly platform or reach out to our customer service team for personalized assistance, ensuring a seamless booking experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for Tempo Traveller rentals in Pune, including outstation trips. Whether you're planning a weekend getaway or a last-minute trip, we are ready to accommodate your travel needs, ensuring you have access to a spacious and reliable vehicle whenever you need it."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our top priority. We are committed to providing exceptional service, ensuring that every Tempo Traveller rental meets the highest standards of comfort, safety and reliability. Our goal is to ensure a smooth and enjoyable travel experience from start to finish."
    }
  ]
  
  
  
  
  

  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent a Tempo Traveller for outstation trips from Pune?",
        answer: "You can easily rent a Tempo Traveller for outstation trips from Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for a Tempo Traveller for outstation trips from Pune?",
        answer: "The rental rate for a Tempo Traveller depends on the distance, duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Tempo Traveller inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent a Tempo Traveller for a one-way outstation trip from Pune?",
        answer: "Yes, we offer one-way rental options for Tempo Traveller for outstation trips from Pune to nearby cities or destinations."
    },
    {
        question: "Do you provide drivers with the Tempo Traveller rental for outstation trips?",
        answer: "Yes, all our Tempo Traveller rentals come with experienced drivers who are familiar with the routes for a smooth and safe journey."
    },
    {
        question: "What is your cancellation policy for Tempo Traveller bookings for outstation trips from Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting a Tempo Traveller for outstation trips from Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Tempo Traveller vehicles insured for safety during outstation trips from Pune?",
        answer: "Yes, all our Tempo Traveller vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Tempo Traveller rental for outstation trips?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting a Tempo Traveller for outstation trips from Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented a Tempo Traveller for an outstation trip from Pune with SHREE Tours & Travels. The vehicle was spacious, comfortable and well-maintained and the driver made the long journey enjoyable.',
        name: 'Mr. Ramesh Nair',
    },
    {
        text: 'SHREE Tours & Travels made our outstation trip unforgettable. The Tempo Traveller was perfect for our group and the driver ensured a safe and smooth journey to all our destinations.',
        name: 'Miss. Anjali Gupta',
    }
];




















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


  const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent Tempo Traveller in Pune for comfortable group travel, family trips, corporate events and outstation travel. Available in 17, 20, 25 and 32 seaters. Book now for affordable and luxury Tempo Traveller hire services.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411017",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/tempo-traveller-rental-pune.jpg",
    "https://shreetoursandtravels.in/img/tempo-traveller-group-travel.jpg"
  ],
  "priceRange": "₹4000 - ₹15000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/tempo-traveller-hire-pune",
    "priceCurrency": "INR",
    "price": 6000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 180
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Anita Deshmukh"
      },
      "datePublished": "2024-07-15",
      "reviewBody": "We rented a 32-seater Tempo Traveller for a family reunion trip to Mahabaleshwar. The vehicle was very comfortable and the driver was professional. It was the perfect choice for a large group. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ravi Sharma"
      },
      "datePublished": "2024-05-22",
      "reviewBody": "Booked a 25-seater Tempo Traveller for a corporate event trip. Excellent service, on-time pick-up and the vehicle was very spacious. Great experience, will use again for future corporate events!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Tempo Traveller Rental in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/tempo-traveller-hire-pune"
  },
  "keywords": "Tempo Traveller Rental Pune, Rent 17 Seater Tempo Traveller Pune, Rent 20 Seater Tempo Traveller Pune, Rent 25 Seater Tempo Traveller Pune, Rent 32 Seater Tempo Traveller Pune, Affordable Tempo Traveller Hire Pune, Tempo Traveller for Group Travel Pune, Book Tempo Traveller for Outstation Pune, Tempo Traveller Hire for Family Travel Pune, Pune to Outstation in Tempo Traveller, Tempo Traveller Hire for Corporate Events Pune, Rent Tempo Traveller for Large Groups Pune, Tempo Traveller for Weekend Trip Pune, Luxury Tempo Traveller Rental Pune"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Tempo Traveller On Rent in Pune for Outstation | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent Tempo Traveller in Pune for comfortable group travel, family trips, corporate events and outstation travel. Available in 17, 20, 25 and 32 seaters. Book now for affordable and luxury Tempo Traveller hire services." />
  <meta name="keywords" content="Tempo Traveller Rental Pune, Rent 17 Seater Tempo Traveller Pune, Rent 20 Seater Tempo Traveller Pune, Rent 25 Seater Tempo Traveller Pune, Rent 32 Seater Tempo Traveller Pune, Affordable Tempo Traveller Hire Pune, Tempo Traveller for Group Travel Pune, Book Tempo Traveller for Outstation Pune, Tempo Traveller Hire for Family Travel Pune, Pune to Outstation in Tempo Traveller, Tempo Traveller Hire for Corporate Events Pune, Rent Tempo Traveller for Large Groups Pune, Tempo Traveller for Weekend Trip Pune, Luxury Tempo Traveller Rental Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/36.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row ">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4 " key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Tempotravelleronrent;